export type DashboardUserWizardFormValues = {
  careTeamFlag?: boolean;
  [key: string]: unknown;
};

export type DashboardUserWizardSubmitValues = {
  careTeamFlag: boolean;
  [key: string]: unknown;
};

/** Own-Organisation wizard form → submit payload with boolean Care Team Flag only. */
export function toDashboardUserWizardSubmit(
  values: DashboardUserWizardFormValues,
): DashboardUserWizardSubmitValues {
  const { careTeamFlag, ...rest } = values;
  return {
    ...rest,
    careTeamFlag: Boolean(careTeamFlag),
  };
}
